import submitLessonValidationStore from "@modules/editor/components/lesson/SubmitLessonValidationStore.ts";

interface Errors {
  mediaObjectList?: string;
}

export function useLessonSubmissionValidation() {
  const removeUnapprovedMOValidationErrorsIfExist = (currentPageId, componentUuid) => {
    const errors: Errors = submitLessonValidationStore.getSubmissionValidationErrors();
    if (errors.mediaObjectList) {
      const foundErrors = errors.mediaObjectList.split(",").filter((activity) => {
        return activity.indexOf(`${currentPageId}_${componentUuid}`) >= 0;
      });
      const newErrors = errors.mediaObjectList.split(",").filter((newError) => {
        let filter = true;
        foundErrors.forEach((error) => {
          if (filter && newError.indexOf(error.split("_")[0]) >= 0) filter = false;
        });
        return filter;
      });
      errors.mediaObjectList = newErrors.toString();
      submitLessonValidationStore.setSubmissionValidationErrors(errors);
    }
  };

  const checkIfUnapprovedMOValidationErrorsExist = (resourceUuid) => {
    let hasError = false;
    const validationErrors: Errors = Object.assign(
      {},
      submitLessonValidationStore.getSubmissionValidationErrors(),
    );
    if (validationErrors && validationErrors.mediaObjectList) {
      const unapprovedMOList = validationErrors.mediaObjectList.split(",");
      if (unapprovedMOList.length == 0) return;
      unapprovedMOList.forEach((unapprovedMO) => {
        if (!hasError && unapprovedMO && unapprovedMO.split("_").length === 3) {
          const errorResourceUuid = unapprovedMO.split("_")[2];
          hasError = resourceUuid === errorResourceUuid;
        } else if (!hasError && unapprovedMO && unapprovedMO.split("_").length > 3) {
          const errorResourceUuid = unapprovedMO.split("_")[2];
          const isAnswerInfo = unapprovedMO.split("_")[3] === "true";

          hasError = resourceUuid === errorResourceUuid && isAnswerInfo;
        }
      });
    }
    return hasError;
  };

  return {
    submitLessonValidationStore,
    removeUnapprovedMOValidationErrorsIfExist,
    checkIfUnapprovedMOValidationErrorsExist,
  };
}
